export default __webpack_public_path__ + "static/media/points-club.69bffc5c.svg";